/**
 * Lectura de la respuesta de GET /summary/process para la confirmación (feature 025).
 * Sin componentes de UI a propósito: se testea sin renderizar Cloudscape.
 */

/**
 * Líneas informativas de la confirmación (FR-042, T093): registros del rango, llamadas con
 * análisis, llamadas que se analizan y en cuántas operaciones se hace el resumen. Una respuesta
 * del backend anterior, sin los campos nuevos, sólo muestra lo que trae.
 */
export function verificationLines(result, t) {
  if (!result) return [];

  const count = result.count || 0;
  const lines = [
    t('insights.recordsFoundInRange', {
      count,
      defaultValue: `Dentro del rango de fechas elegido se encontraron ${count} registros`,
    }),
  ];

  if (typeof result.calls_with_cx === 'number') {
    lines.push(t('insights.callsWithCx', {
      count: result.calls_with_cx,
      defaultValue: `${result.calls_with_cx} llamadas tienen análisis de experiencia`,
    }));
  }
  if (typeof result.calls_to_analyze === 'number') {
    lines.push(t('insights.callsToAnalyze', {
      count: result.calls_to_analyze,
      defaultValue: `Se van a analizar ${result.calls_to_analyze} llamadas`,
    }));
  }
  if (typeof result.batches === 'number' && result.batches > 0) {
    lines.push(t('insights.summaryBatches', {
      count: result.batches,
      defaultValue: result.batches === 1
        ? 'El resumen se hace en 1 operación'
        : `El resumen se hace en ${result.batches} operaciones`,
    }));
  }
  return lines;
}

/**
 * Opción A (T086): con el máximo por corrida superado el backend responde ready_to_process: false
 * y la pantalla no deja confirmar. Una respuesta sin el campo (backend anterior) se puede confirmar.
 */
export function canConfirmSummary(result) {
  if (!result) return false;
  return result.ready_to_process !== false;
}

/** Por qué no se puede generar: el message del backend o uno propio con N y M. */
export function exceedsCapMessage(result, t) {
  if (result && result.message) return result.message;
  const withCx = result?.calls_with_cx ?? 0;
  const max = result?.max_calls_per_run ?? 0;
  return t('insights.exceedsCap', {
    withCx,
    max,
    defaultValue: `El filtro tiene ${withCx} llamadas con análisis y el máximo por resumen es ${max}. Acotá las fechas.`,
  });
}
